module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading1 || _vm.isLoading2),
      expression: "isLoading1 || isLoading2"
    }],
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [_c('div', {
    staticClass: "warpper"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.tab))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "30px 0"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "80px 12% 0 8%"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-form', {
    ref: "tabelForm",
    attrs: {
      "label-position": "top",
      "label-width": "80px",
      "model": _vm.tabelForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "区域名称"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "prop": "areaName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "例：2楼A区"
    },
    model: {
      value: (_vm.tabelForm.areaName),
      callback: function($$v) {
        _vm.$set(_vm.tabelForm, "areaName", $$v)
      },
      expression: "tabelForm.areaName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("此内容展示在桌号之前，选填")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "桌号范围",
      "prop": "startNum"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "startNum",
      "placeholder": "起始桌号"
    },
    model: {
      value: (_vm.tabelForm.startNum),
      callback: function($$v) {
        _vm.$set(_vm.tabelForm, "startNum", _vm._n($$v))
      },
      expression: "tabelForm.startNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "至"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "endNum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "结尾桌号"
    },
    model: {
      value: (_vm.tabelForm.endNum),
      callback: function($$v) {
        _vm.$set(_vm.tabelForm, "endNum", _vm._n($$v))
      },
      expression: "tabelForm.endNum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("请填写纯数字，如只需生成一张二维码，则不必填写结尾桌号")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.createBtnDisabled
    },
    on: {
      "click": function($event) {
        _vm.submitForm('tabelForm')
      }
    }
  }, [_vm._v("生成二维码")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "border-left": "1px solid #e7eaec",
      "padding": "0 60px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('figure', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPreview),
      expression: "isPreview"
    }]
  }, [_c('img', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "src": require("./img/qrcode-demo.png"),
      "alt": "二维码预览"
    }
  }), _vm._v(" "), _c('p', [_vm._v("二维码预览")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreview),
      expression: "!isPreview"
    }],
    staticClass: "realQrcode"
  }, [_c('figure', {
    attrs: {
      "id": "tablePreview"
    }
  }, [_c('canvas', {
    attrs: {
      "width": "350",
      "height": "455"
    }
  }), _vm._v(" "), _c('p', [_vm._v("已生成"), _c('em', [_vm._v(_vm._s(_vm.tabelNumbers.length))]), _vm._v("个桌贴")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.downloadTabelBtnDisabled
    },
    on: {
      "click": function($event) {
        _vm.downloadTabel()
      }
    }
  }, [_vm._v("下载桌贴")])], 1), _vm._v(" "), _c('figure', {
    attrs: {
      "id": "qrcodePreview"
    }
  }, [_c('canvas', {
    attrs: {
      "width": "350",
      "height": "455"
    }
  }), _vm._v(" "), _c('p', [_vm._v("已生成"), _c('em', [_vm._v(_vm._s(_vm.tabelNumbers.length))]), _vm._v("个二维码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.downloadQrcodeBtnDisabled
    },
    on: {
      "click": function($event) {
        _vm.downloadQrcode()
      }
    }
  }, [_vm._v("下载二维码")])], 1)])])], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bg",
      "src": require("./img/bg.jpg"),
      "alt": "点餐桌贴"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "tableQrcodeContainer"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "qrcodeContainer"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("输入桌牌信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52c7b98b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dcqrcode/dcqrcode.vue
// module id = 819
// module chunks = 1